import * as React from 'react';
import { IColorTag, TBoardId, TCardId, TListId, TTag } from '../../../../../../../../types/types';
import { IMainDriveDoc } from '../../../../../../../../store/model/card/types/IMainDriveDoc';
import { ICollaborator } from '../../../../../../../../store/collaborators/collaborators/types';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { IRestRecurringTask } from '../../../../../../../../types/rest/recurringTask/IRestRecurringTask';
import { ICardAssigneeRole } from '../../../../../../../../types/model';
import { ECardAgingIndicatorType } from '../../../../../../../../types/rest/ICardAging';
import { IAssigneeRest } from '../../../../../../../../types/rest/IAssigneeRest';
import { ICardChecklists } from '../../../../../../../../store/model/checklists/checklists/types';
import { ICard } from '../../../../../../../../store/model/card/types';
import {
    ICustomPropertiesElement
} from '../../../../../../base/components/CustomProperties/components/CustomProperty/types';

export enum EQuickLookType {
    ATTACHMENTS = 'ATTACHMENTS',
    CHECKLISTS = 'CHECKLISTS',
    COMMENTS = 'COMMENTS',
    DESCRIPTION = 'DESCRIPTION',
    SUBCARDS = 'SUBCARDS'
}

export interface ICardFields {
    boardId: TBoardId
    assignees: IAssigneeRest[]
    attachmentsCount: number;
    backgroundColor: string;
    cardNumber: string;
    isShowChecklistsCounter: boolean;
    checklists: ICardChecklists;
    checklistsItemsCount: number;
    collaborators: ICollaborator[];
    colorTags: IColorTag[];
    commentCount: number;
    customProperties: ICustomPropertiesElement[];
    description?: string;
    doneChecklistsCount: number;
    dueDate: number;
    epicName: string;
    estimate: number;
    hasDescription: boolean;
    id: TCardId;
    isCovered: boolean;
    isFullLoaded?: boolean;
    isHideDoneChecklistItems: boolean;
    isNotFilled: boolean;
    isPinnedDescription?: boolean;
    isPinnedSubcards?: boolean;
    isPinnedCustomProperties?: boolean;
    isReadonly: boolean;
    isSelected: boolean;
    isFakeCovered: boolean; // для тестов
    isRecentlyWatched: boolean;
    isRelatedCardEdit?: boolean;
    isRelatedPanel: boolean;
    isTemplate?: boolean;
    listId: TListId;
    mainDriveDocSet: IMainDriveDoc[];
    name: string;
    openedQuickLook: EQuickLookType;
    percent: number;
    pinnedChecklistCount?: number;
    priority: string;
    processingStatus: string;
    startDate: number;
    subcards: ICard[];
    subCardsCount: number;
    tags: TTag[];
    hideActions?: boolean;
    isRecurring?: boolean;
    recurringTasks: IRestRecurringTask[];
    isCardAgingOpacity: boolean;
    cardAgingIndicator: ECardAgingIndicatorType;
    timeSinceLastActivity?: number;
    timeSinceMovedToList?: number;

    dragHandleProps?: DraggableProvidedDragHandleProps;
    actionsPortalId?: string;
    editedNameCardId: TCardId;
    boardRoles: ICardAssigneeRole[];
    height: number;
    isDefaultTemplate: boolean;
    isDragging?: boolean;
    isMultipleDragging: boolean;
    isHighlight?: boolean;
    isMultiselect: boolean;
    isListVisible?: boolean;
    isShowAgeing: boolean;
    isShowAssignees: boolean;
    isShowColorTags: boolean;
    isShowCounters: boolean;
    isShowDueDate: boolean;
    isShowEmptyProperties: boolean;
    isShowEstimate: boolean;
    isShowPrefixes: boolean;
    isShowPriority: boolean;
    isShowProgress: boolean;
    isShowStartDate: boolean;
    isShowTags: boolean;
    isQuickLookCollapse: boolean;
    viewListId?: string;
}

export interface ICardEvents {
    onCardClick: (e: React.MouseEvent) => void;
    onDidMount: () => void;
    setHeight?: (height: number) => void;
    onAnimationEnd?: () => void;
    onCheckboxClick: () => void;
    onHideHint: () => void;
    onQuickLookChange: (quickLook: EQuickLookType) => void;
    onLoadData: () => Promise<boolean>;
    onDoubleClickEvent: () => void;
}

export interface ICardProps extends
    ICardEvents,
    ICardFields
{}
